// import events from '@/core/events/events'

export const extendedBus = (bus) => {
  //
  const eventSource = bus.$emit
  const eventSink = bus.$on

  function emitEvent (event, payload) {
    return eventSource.call(bus, event, payload)
  }
  function onEvent (event, cb) {
    return eventSink.call(bus, event, cb)
  }

  bus.$emit = function (event, payload, source) {
    const _source = source || { name: global.app.currentModule }
    const _payload = {
      target: _source.name,
      data: payload
    }

    console.info('emitted', event, 'from', _source.name, 'with payload', _payload)
    if (event) {
      emitEvent.call(bus, event, _payload)

      /* events.queue.push({
        type: event,
        data: _payload
      }) */

      // pubnub
      global.app.$pubnub && global.app.$pubnub.publish({
        message: {
          data: event
        },
        channel: 'hello_world',
        sendByPost: false, // true to send via post
        storeInHistory: false, // override default storage options
        meta: {
          'cool': 'meta'
        } // publish extra meta with the request
      },
      function (status, response) {
        if (status.error) {
          // handle error
          console.log(status)
        } else {
          console.log('message Published w/ timetoken', response.timetoken)
        }
      })
    } else {
      console.warn('this event is undefined')
    }
  }

  bus.$on = function (event, cb, sink) {
    console.info('attached', event)

    onEvent.call(bus, event, (payload) => {
      const _sink = sink && sink.default || {}

      console.info('received', event, _sink.name ? 'in' : '', _sink.name ? _sink.name : '')
      if (typeof cb === 'function') {
        cb(payload)
      }
    })
  }

  return bus
}



// WEBPACK FOOTER //
// ./src/core/events/extended-bus.js